<template>
  <div class="mb-3">
    <label v-if="label" class="form-label" :for="id">
      <span>{{ label }}</span>
      <span v-if="required" class="text-danger">{{ required ? '*' : '' }}</span>
      <div v-if="hint" class="d-block fw-light text-secondary lh-1 mb-1 fs-6">
        <small> {{ hint }}</small>
      </div>
    </label>
    <select
      :name="id"
      :id="id"
      ref="input"
      v-model="selected"
      v-bind="$attrs"
      :class="['form-select form-select-lg']"
    >
      <slot />
    </select>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: [String, Number, Boolean],
    label: String,
    error: String,
    hint: String,
  },
  data() {
    return {
      selected: this.value,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('input', selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>

<style lang="scss" scoped></style>
